import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=16921a58"
import script from "./ContentBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports